import { createFileRoute } from '@tanstack/react-router'

import { WaiterLoginForm } from '#components/features/auth/waiter-login-form'

export const Route = createFileRoute('/garcom/')({
  head: () => ({
    meta: [
      { title: 'App do Garçom | UseComanda' },
      {
        name: 'description',
        content:
          'Acesse o App do Garçom. Gerencie, mesas e comandas em tempo real.',
      },
      { property: 'og:title', content: 'App do Garçom | UseComanda' },
      {
        property: 'og:description',
        content: 'Faça login para gerenciar mesas e comandas.',
      },
    ],
  }),
  component: WaiterLoginPage,
})

function WaiterLoginPage() {
  return (
    <div className="bg-background flex min-h-svh flex-col items-center justify-center gap-6 p-6 md:p-10">
      <div className="w-full max-w-sm">
        <WaiterLoginForm />
      </div>
    </div>
  )
}
